import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Carregando...", 
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12'
  };

  return (
    <div className="text-center py-8">
      <div className={`${sizeClasses[size]} border-2 border-brand-accent border-t-transparent rounded-full animate-spin mx-auto mb-4`}></div>
      <p className="text-brand-ink/60">{message}</p>
    </div>
  );
};

export default LoadingSpinner;
